import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';
import Navbar from "../Navbar/Navabar";
import Footer from "../../components/Footer/Footer";
// Import components
import HeroCarousel from '../../components/HeroCarousel/HeroCarousel';
import ClientLogos from '../../components/ClientLogos/ClientLogos';
import AboutSection from '../../components/AboutSection/AboutSection';
import ServicesSection from '../../components/ServicesSection/ServicesSection';
import StatsSection from '../../components/StatsSection/StatsSection';
import TestimonialsSection from '../../components/TestimonialsSection/TestimonialsSection';
import CtaSection from '../../components/CtaSection/CtaSection';
import WhatsAppButton from '../../components/WhatsAppButton/WhatsAppButton';

// import './App.css';

function Homepage() {
  const [animatedItems, setAnimatedItems] = useState({
    stats: false,
    services: false,
    testimonials: false
  });

  // For stats section animation
  const { ref: statsRef, inView: statsInView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  // For services section animation
  const { ref: servicesRef, inView: servicesInView } = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  // For testimonial section animation
  const { ref: testimonialRef, inView: testimonialInView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  useEffect(() => {
    if (statsInView && !animatedItems.stats) {
      setAnimatedItems(prev => ({ ...prev, stats: true }));
    }
    if (servicesInView && !animatedItems.services) {
      setAnimatedItems(prev => ({ ...prev, services: true }));
    }
    if (testimonialInView && !animatedItems.testimonials) {
      setAnimatedItems(prev => ({ ...prev, testimonials: true }));
    }
  }, [statsInView, servicesInView, testimonialInView, animatedItems]);

  return (
    <div className="App">
            <Navbar />
      
      <HeroCarousel />
      <ClientLogos />
      <AboutSection />
      <ServicesSection 
        animatedItems={animatedItems} 
        servicesRef={servicesRef} 
      />
      <StatsSection 
        animatedItems={animatedItems} 
        statsRef={statsRef} 
      />
      <TestimonialsSection 
        animatedItems={animatedItems} 
        testimonialRef={testimonialRef} 
      />
      <CtaSection />
      <WhatsAppButton />
      <Footer />
      
      {/* Bootstrap JS and dependencies */}
    </div>
  );
}

export default Homepage;